import { inject, Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql } from 'app/shared/graph';

@Injectable({
    providedIn: 'root'
})
export class NavigationBuilderService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    getActionRequiredCount(storeId: string): Observable<number> {
        return this.graphDotnetService.query(graphql`
                query getLines($storeId: String!, $startDate: DateTime) {
                    store(id: $storeId) {
                        lines(flag:StoreActionRequired, startDate: $startDate, top: 100) {
                            ... on OrderLine {
                                __typename
                                id
                            }
                        }
                    }
                }
            `,
            { storeId, startDate: new Date(new Date().getTime() - 120 * 24 * 3600 * 1000) }
        ).pipe(map((result) => (result.store && result.store.lines).length || 0));
    }
}
